import React from "react";

type UrlHelperProps = {
  children: string;
}
  
const urlRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gim;

export default function HyperlinkTextHelper(props: UrlHelperProps) {
  const { children } = props;
  
  const plainTextToTextWithLinks = (text: string) =>
  {
    const parts = children.split(urlRegex);
    const urls = text.match(urlRegex) ?? [];
    if (urls.length == 0)
    {
      return <>{text}</>
    }

    //parts always has one more item than urls and plain text always comes before url
    //e.g. parts = ['',''], urls = ['https://www.instagram.com'] for 'https://www.instagram.com/'
    const fragments : string[] = [ parts[0] ];
    for (let i = 1; i < parts.length; i++)
    {
      fragments.push(urls[i - 1]!);
      fragments.push(parts[i]!);
    }

    return (
      fragments.map((f, ind) =>
      (
        ind % 2 === 0 ?
          <React.Fragment key={ind}>{f}</React.Fragment> :
          <a key={ind} href={f} target="_blank">{f}</a>
      ))
    )    
  }

  return (
    <React.Fragment>
      {plainTextToTextWithLinks(children)}
    </React.Fragment>
  )
}
